import { useEffect, useState } from "react";
import ListingHeader from "./ListingHeader";
import AddressModal from "./AddressModal";
import { _vendorAdminRoutes } from "../../../utils/appRouter";
import { apiUrl } from "../../../utils/endPoints/apiUrl";
import { apiRequest } from "../../../utils/config/apiRequest";
import { useNavigate, useLocation } from "react-router-dom";
import Pagination from "../../../comman/Pagination";
import { fDateUTC } from "../../../utils/helper/timeHelpers";
import { useDispatch, useSelector } from "react-redux";
import { fetchShopList } from "../../../store/slices/shopSlice";
import { useSearchParams } from "react-router-dom";
import { Chip, Stack } from "@mui/material";


const Listings = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState({ address: false });
  const [orderLisitngs, setOrderLisitngs] = useState({ rows: [], count: 0 });
  const [isLoading, setIsLoading] = useState(false);

  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [activeTab, setActiveTab] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();
  const { shopListing } = useSelector((state) => state.shops);

  const shops = shopListing?.rows?.map((s) => ({
    id: s._id,
    name: s.name,
  }));

  const [count, setCount] = useState({
    new: 0,
    today: 0,
    completed: 0,
    pending: 0,
  });

  const fetchOrderLisiting = async () => {
    if (!activeTab) return;

    try {
      setIsLoading(true);

      const { data, status } = await apiRequest({
        endUrl: apiUrl.orders.root,
        query: {
          ...(activeTab !== "all" && { type: activeTab }),
          ...(selectedBranch && { shopId: selectedBranch }),
          ...(selectedCustomer?._id && { customerId: selectedCustomer._id }),
          ...pagination,
        },
      });

      if (status) {
        setOrderLisitngs({
          rows: data?.rows || [],
          count: data?.total || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchOrderCount = async () => {
    try {

      const { data, status } = await apiRequest({
        endUrl: apiUrl.orders.orderCount,
        query: {
          ...(selectedBranch && { shopId: selectedBranch }),
          ...(selectedCustomer?._id && { customerId: selectedCustomer._id }),
        },
      });

      if (status) setCount(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDownloadInvoice = async (orderId) => {
    try {
      const response = await apiRequest({
        method: "GET",
        endUrl: apiUrl.orders.downloadInvoice(orderId),
      });

      if (response?.isPdf) {
        const url = window.URL.createObjectURL(response.data);

        const a = document.createElement("a");
        a.href = url;
        a.download = `invoice-${orderId}.pdf`;
        document.body.appendChild(a);
        a.click();

        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error("Invoice download failed", err);
    }
  };


  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
      setPagination({ page: 1, limit: 10 });
    } else {
      setActiveTab("all");
    }
  }, [location.state]);


  useEffect(() => {
    if (searchParams.get("customerId") && !selectedCustomer) return;
    fetchOrderLisiting();
  }, [activeTab, pagination.page, pagination.limit, selectedBranch, selectedCustomer?._id,]);

  useEffect(() => {
    if (searchParams.get("customerId") && !selectedCustomer) return;

    fetchOrderCount();
  }, [selectedBranch, selectedCustomer?._id]);



  const handleView = (id) => {
    navigate(_vendorAdminRoutes.orders.view(id));
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPagination({ page: 1, limit: 10 });
  };

  useEffect(() => {
    dispatch(fetchShopList());
  }, [dispatch]);

  useEffect(() => {
    const customerId = searchParams.get("customerId");
    const customerName = searchParams.get("customerName");

    if (customerId) {
      setSelectedCustomer({
        _id: customerId,
        name: customerName,
      });
    }
  }, []);


  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <ListingHeader
          total={orderLisitngs.count}
          pagination={pagination}
          setPagination={setPagination}
          count={count}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />

        <div className="col-md-6 mt-2" style={{ marginLeft: "-13px" }}>
          <label style={{ marginBottom: "6px" }}>Select branch</label>
          <div className="d-flex align-items-center">
            <select
              className="form-control mr-3"
              style={{ width: "180px" }}
              value={selectedBranch}
              onChange={(e) => setSelectedBranch(e.target.value)}
            >
              <option value="" disabled>
                Select Branch
              </option>

              {shops.map((branch) => (
                <option key={branch?.id} value={branch?.id}>
                  {branch.name}
                </option>
              ))}
            </select>

            {selectedCustomer && (
              <Stack direction="row" alignItems="center">
                <Chip
                  label={selectedCustomer.name}
                  color="primary"
                  variant="outlined"
                  onDelete={() => {
                    setSelectedCustomer(null);
                    searchParams.delete("customerId");
                    searchParams.delete("customerName");
                    setSearchParams(searchParams);
                  }}
                />
              </Stack>
            )}

          </div>
        </div>


        <div className="table-responsive bg-white mt-3">
          <table className="table table-striped table-bordered admintable">
            <tbody>
              <tr className="text-center">
                <th>#</th>
                <th>Booking No</th>
                <th>Customer</th>
                <th>Van</th>
                <th>Delivery Type</th>
                <th>Time Slot</th>
                <th>Service</th>
                <th>Amount</th>
                <th>Address</th>
                <th>Branch Name</th>
                <th>Created On</th>
                <th>Invoice</th>
                <th>Status</th>
                <th>Action</th>
              </tr>

              {orderLisitngs.rows.length ? (
                orderLisitngs.rows.map((item, index) => (
                  <tr key={item._id}>
                    <td>
                      {(pagination.page - 1) * pagination.limit + index + 1}
                    </td>
                    <td>{item.orderNo}</td>
                    <td>
                      <strong>{item?.customerInfo?.userName}</strong>
                      <br />
                      {item?.customerInfo?.mobileNo}
                    </td>
                    <td>{item?.vanService ? 'Yes' : 'No'}</td>
                    <td>{
                      item?.deliveryType === 'EXPRESS' ?
                        <span className="badge badge-success">
                          Express
                        </span>
                        : item?.deliveryType === 'STANDARD' ?
                          <span className="badge badge-warning text-dark">
                            Standard
                          </span> :
                          <span className="badge badge-success">
                            Self
                          </span>
                    }</td>
                    <td className="text-center">
                      {
                        item?.scheduleFromTime && item?.scheduleFromTime ? `${item?.scheduleFromTime} - ${item?.scheduleToTime}` : '---'
                      }
                    </td>
                    <td>{item?.serviceInfo?.name}</td>
                    <td>${Number(item?.priceInfo?.payableAmount || 0).toFixed(2)}</td>
                    <td>
                      {item?.deliveryAddress?.addressLine1.length > 25 ? item?.deliveryAddress?.addressLine1.substring(0, 25) + '...' : item?.deliveryAddress?.addressLine1 || '--'}
                      <br />
                      <a className="text-orange" onClick={() => setModalShow({ ...modalShow, address: true, data: item?.deliveryAddress?.addressLine1 })} style={{ cursor: 'pointer' }}>
                        Click to View
                      </a>
                    </td>
                    <td>{item.shopInfo?.name}</td>
                    <td>{fDateUTC(item?.createdAt, null, "DD MMM, YYYY")}</td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => handleDownloadInvoice(item._id)}
                      >
                        <i className="fa fa-download"></i> Invoice
                      </button>
                    </td>
                    <td>
                      <span className={`badge badge-${item?.status === "COMPLETED" ? "success" : "warning"}`}>
                        {item?.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="dropdown-item"
                        onClick={() => handleView(item._id)}
                      >
                        <i className="fa fa-eye"></i> View Details
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} className="text-center py-4">
                    {isLoading ? "Loading..." : "No orders found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* {console.log(orderLisitngs.count)}
        {console.log(orderLisitngs)} */}

        <Pagination
          page={pagination.page}
          limit={pagination.limit}
          total={orderLisitngs.count}
          onPageChange={(page) =>
            setPagination((prev) => ({ ...prev, page }))
          }
          showAlways={true}
        />
      </div>

      <AddressModal modalShow={modalShow} setModalShow={setModalShow} />
    </section>
  );
};

export default Listings;
